var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"canvas-invoice"},[_c('div',{staticClass:"img-preview-wrp"},[_c('div',{staticClass:"modal"}),_c('img',{ref:"imgRef",staticClass:"img-wrp",style:({transform: `scale(${_vm.scale}) translate(${_vm.translateX}px, ${_vm.translateY}px)`}),attrs:{"id":"previewImg","src":_vm.img}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }